import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core"
import { FormBuilder, FormGroup, Validators } from "@angular/forms"
import { Subscription } from "rxjs"
import { WifiService } from "../../shared/services/wifi.service"
import { ConfigService } from "../../shared/services/config.service"
import { BottomSheetOverviewComponent } from "../bottom-sheet-overview/bottom-sheet-overview.component"
import { MatBottomSheet } from "@angular/material/bottom-sheet"
import { TranslateService } from "@ngx-translate/core";
import { InstitutionService } from "src/app/shared/services/institution.service"
import { ThemeService, ThemeColor } from "src/app/shared/services/theme/theme.service"
import { Router } from "@angular/router"

@Component({
  selector: "app-wifi-connection",
  templateUrl: "./wifi-connection.component.html",
  styleUrls: ["./wifi-connection.component.css"]
})
export class WifiConnectionComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild("hheWifiAuthForm")
  wifiAuthForm: ElementRef

  subscriptions: Subscription = new Subscription()
  detailForm: FormGroup

  wifiAccessCreated = false
  wifiUsername: string = "";
  wifiPassword: string = "";
  wifiWelcomeUrl?: string;
  wifiApAuthUrl: String = ""

  constructor(
    public translate: TranslateService,
    private bottomSheet: MatBottomSheet,
    private configService: ConfigService,
    private formBuilder: FormBuilder,
    private wifiService: WifiService,
    private institutionService: InstitutionService,
    private themeService: ThemeService,
    private router: Router,
  ) { /* do nothing */ }

  ngOnInit(): void {
    this.initForm(
      this.configService.getAccessCode()
    )
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(this.institutionService.getInstitution().subscribe(institution => {
      this.themeService.setTheme(institution as ThemeColor)
    }))
  }

  initForm(accessCode: string): void {
    let form: { [key: string]: any }
    form = {
      accessCode: [accessCode, Validators.required],
    }
    this.detailForm = this.formBuilder.group(form)
    if (accessCode) {
      this.tryConnection()
    }
  }

  tryConnection(): void {
    this.subscriptions.add(
      this.wifiService.createConnectionToWifi(this.detailForm.value.accessCode).subscribe((data) => {
        let text = this.translate.instant("wifiRedirect")
        if (data.error === "ERR_DEVICE_LIMIT") {
          text = this.translate.instant("wifiUnloggedRedirect")
        }
        this.bottomSheet.open(BottomSheetOverviewComponent, { data: { text } })

        this.wifiAccessCreated = true
        this.wifiUsername = data.username
        this.wifiPassword = data.password
        this.wifiWelcomeUrl = data.welcomeUri
        this.wifiApAuthUrl = data.authUri
        setTimeout(() => {
          this.wifiAuthForm.nativeElement.requestSubmit()
        }, 3000)
      }
      )
    )
  }

  backToHome(): void {
    this.router.navigate(["/home"])
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
